import React, { useEffect, useState } from "react";
import useThemeColors from "../ThemeColors";
import { capitalizeFirstLetter } from "../../../components/reusableComponent/CapitalLetter";
import { useConsentMasterQuery } from "../../../Services/vehicle/Vehicle";
import LoadingSpinner from "../../../components/LoadingSpinner";
import ReactModal from "react-modal";
import CreateConsentMaster from "./CreateConsentMaster";
import ActiveConsent from "./ActiveConsent";
import InactiveConsent from "./InactiveConsent";
import UpdateConsentMaster from "./UpdateConsent";
import { formatDate } from "../../../components/reusableComponent/DateFormat";

const Consent = () => {
  const [consentMasterData, setConsentMasterData] = useState([]);
  const [tableLoader, setTableLoader] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [storedWOrkshopData, setStoredWorkshopData] = useState({});
  const [isInactiveModalOpen, setIsInactiveModalOpen] = useState(false);
  const [isActiveModalOpen, setIsActiveModalOpen] = useState(false);
  const [editConsentMaster, setEditConsentMaster] = useState(false);

  const {
    data: getMasterData,
    isLoading,
    status,
    refetch,
  } = useConsentMasterQuery({});

  useEffect(() => {
    if (status === "pending") {
      setTableLoader(true);
    } else {
      setTableLoader(false);
    }
  }, [status]);

  console.log(getMasterData, "masterData");

  useEffect(() => {
    if (getMasterData) {
      setConsentMasterData(getMasterData?.data);
    }
  }, [getMasterData]);
  const {
    selectedColor,
    selectedBackgroundColor,
    selectedBorderColor,
    selectedButtonBackgoundColors,
    selectedButtonColors,
  } = useThemeColors();

  const closeModal = () => {
    setModalOpen(false);
    setEditConsentMaster(false);
    setIsActiveModalOpen(false);
    setIsInactiveModalOpen(false);
  };

  const customModalStyles1: ReactModal.Styles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-40%, -50%)",
      width: "70%",
      border: "none",
    },
  };

  const customModalStyles: ReactModal.Styles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-40%, -50%)",
      width: "30%",
      // border: "none"
    },
  };

  const inactiveHandler = (workshop) => {
    setStoredWorkshopData(workshop);
    setIsActiveModalOpen(true);
  };

  const activeHandler = (workshop) => {
    setStoredWorkshopData(workshop);
    setIsInactiveModalOpen(true);
  };

  const editConsentDataHandler = (data) => {
    setStoredWorkshopData(data);
    setEditConsentMaster(true);
  };

  console.log(consentMasterData, "consentMasterData")

  return (
    <div className="vehicle-info-cont">
      {/* <div>
          </div> */}
      <div className="workshops-container">
        <div className="workshops-header">
          <p
            style={{
              margin: "0",
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ fontWeight: "600", fontSize: "20px" }}>
              Consent Details
            </span>
            <span
              onClick={() => setModalOpen(true)}
              style={{
                color: `${selectedButtonColors}`,
                background: `${selectedButtonBackgoundColors}`,
                border: "none",
                padding: "10px 15px",
                borderRadius: "20px",
                cursor: "pointer",
              }}
            >
              + Add Consent
            </span>
          </p>
        </div>
        {isLoading || tableLoader ? (
          <LoadingSpinner />
        ) : (
          <div className="workshops-table-container">
            <table className="workshops-table">
              <thead>
                <tr style={{ background: "#F7D3C5" }}>
                  <th className="table-header">Sr.no</th>
                  <th className="table-header">Name</th>
                  <th className="table-header">Consent code</th>
                  <th className="table-header">Description</th>
                  <th className="table-header">Mandatory</th>
                  <th className="table-header">Created at</th>
                  {/* <th className='table-header'>Status</th> */}
                  <th className="table-header">Actions</th>
                </tr>
              </thead>
              <tbody>
                {consentMasterData?.map((workshop, index) => (
                  <tr
                    key={workshop.id}
                    className={index % 2 === 1 ? "row-alternate" : "row-normal"}
                  >
                    <td className="table-cell">{index + 1}</td>
                    <td className="table-cell">{workshop?.name}</td>
                    <td className="table-cell">{workshop?.code}</td>
                    <td className="table-cell">{workshop.description}</td>
                    <td className="table-cell">
                      {workshop?.is_mandatory ? "True" : "False"}
                    </td>
                    <td className="table-cell">
                      {formatDate(workshop?.created_at)}
                    </td>
                    {/* <td className="table-cell">{capitalizeFirstLetter(workshop.status)}</td> */}

                    <td className="table-cell">
                      <div
                        className="action-buttons"
                        style={{ alignItems: "center" }}
                      >
                        {/* <button className="view-btn">
                      <span data-toggle="tooltip" data-placement="top" title="Preview" className="icon eye-icon" 
                      // onClick={() => completeWorkshopDataHandler(workshop?.id)}
                      ></span>
                    </button> */}
                        <button className="edit-btn">
                          <span
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Edit"
                            className="icon edit-icon"
                            onClick={() => editConsentDataHandler(workshop)}
                          ></span>
                        </button>
                        <div>
                          {workshop?.is_active ? (
                            <span onClick={() => inactiveHandler(workshop)}>
                              <img src="/Active.svg" alt="active" />
                            </span>
                          ) : (
                            <span onClick={() => activeHandler(workshop)}>
                              <img src="/Inactive.svg" alt="inactive" />
                            </span>
                          )}
                        </div>
                        {/* <button className="delete-btn">
                      <span className="icon delete-icon" onClick={() => inactiveHandler(workshop) }></span>
                    </button> */}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <ReactModal
          isOpen={modalOpen}
          onRequestClose={closeModal}
          style={customModalStyles1}
        >
          <CreateConsentMaster closeModal={closeModal} refetch={refetch} />
        </ReactModal>

        <ReactModal
          isOpen={isInactiveModalOpen}
          onRequestClose={closeModal}
          style={customModalStyles}
        >
          <ActiveConsent
            storedWorkshopData={storedWOrkshopData}
            closeModal={closeModal}
            refetch={refetch}
          />
        </ReactModal>

        <ReactModal
          isOpen={isActiveModalOpen}
          onRequestClose={closeModal}
          style={customModalStyles}
        >
          <InactiveConsent
            storedWorkshopData={storedWOrkshopData}
            closeModal={closeModal}
            refetch={refetch}
          />
        </ReactModal>

        <ReactModal
          isOpen={editConsentMaster}
          onRequestClose={closeModal}
          style={customModalStyles1}
        >
          <UpdateConsentMaster
            storedWorkshopData={storedWOrkshopData}
            closeModal={closeModal}
            refetch={refetch}
            consentMasterData={consentMasterData}
          />
        </ReactModal>
      </div>
    </div>
  );
};

export default Consent;
